import { getChunkLoadErrorAdditional, getChunkLoadErrorMessage, parseChunkLoadError } from '../chunkLoadError';

export function transformErrorBoosterError(error: Ya.Rum.NormalizedError): Ya.Rum.TransformedError {
    const chunkLoadError = parseChunkLoadError(error);

    if (chunkLoadError === null) {
        return error;
    }

    return {
        ...error,
        message: getChunkLoadErrorMessage(chunkLoadError.chunkType),
        level: 'warn',
        additional: {
            ...error.additional,
            ...getChunkLoadErrorAdditional(chunkLoadError),
        },
    };
}
